/* istanbul ignore file */
import { Button } from 'framework/ui/mui-builder';
import { useFormContext } from 'framework/form';
import { Box, Stack } from '@mui/material';
import { SubmitButton } from 'framework/ui/ui-builder';

const ModificationTokenButtonLayout = ({ handleCleanClick }: { handleCleanClick: () => void }) => {
  const { submitForm = () => {}, isSubmitEnabled } = useFormContext();

  return (
    <>
      <Box mt={2.5}>
        <Stack
          sx={{
            minWidth: '200px',
            '&:not(:last-child)': { marginBottom: 1.25 },
          }}
          direction="row"
          gap={1.25}
        >
          <SubmitButton key="submit-modal-btn" onClick={submitForm} disabled={!isSubmitEnabled} />
          <Button variant="outlined" key="cancel-modal-btn" onClick={handleCleanClick}>
            Clean
          </Button>
        </Stack>
      </Box>
    </>
  );
};

export default ModificationTokenButtonLayout;
